import { QuestionType } from '@/shared/lib/sj-orm/models/form/question.dto';
import { omit } from '@/shared/utils/omit';

import {
  DriversLicenseCategoriesList,
  DriversLicenseCategory,
  PersonalIdentifierDetails,
} from '../../sj-orm';
import { TDtoWrapper } from '../form-wrapper.types';

import {
  commonDetailsFields,
  commonGeneralFields,
  commonLegalizedCopiesFields,
  LegalizedCopiesPartType,
  PersonalIdentifierDetailsFormType,
  PersonalIdentifierGeneralFormType,
} from './commonFields';

export type InternationalDriverLicenseGeneralFormType = PersonalIdentifierGeneralFormType;

export const InternationalDriverLicenseGeneralSection: InternationalDriverLicenseGeneralFormType = {
  ...commonGeneralFields,
};

export type InternationalDriverLicenseDetailsDto = Omit<
  PersonalIdentifierDetails,
  'createdAt' | 'updatedAt'
> & {
  category?: string;
  otherCategory?: string;
  restrictions?: string;
};

type InternationalDriverLicenseHelp = {
  category: QuestionType.SELECT_FROM_LIST;
  otherCategory: QuestionType.TEXT;
  restrictions: QuestionType.TEXT;
};

export type InternationalDriverLicenseDetailsFormType = Omit<
  PersonalIdentifierDetailsFormType,
  'basisForIssuingId' | 'placeOfBirth'
> &
  TDtoWrapper<InternationalDriverLicenseDetailsDto, InternationalDriverLicenseHelp>;

export const InternationalDriverLicenseDetailsSection: InternationalDriverLicenseDetailsFormType = {
  category: {
    type: QuestionType.SELECT_FROM_LIST,
    label: 'forms_personal_ids:driverLicense.inputs.category.label',
    items: DriversLicenseCategoriesList,
    order: 6,
  },
  otherCategory: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:driverLicense.inputs.otherCategory.label',
    value: '',
    order: 6,
    disableIf: {
      category: {
        value: DriversLicenseCategory.other,
      },
    },
  },
  restrictions: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:driverLicense.inputs.restrictions.label',
    value: '',
    capitalized: true,
    order: 9,
  },
  ...omit(commonDetailsFields, 'basisForIssuingId', 'placeOfBirth'),
};

export const InternationalDriverLicenseLegalizedCopiesSection: LegalizedCopiesPartType = {
  ...commonLegalizedCopiesFields,
};

export const InternationalDriverLicenseFormSections = [
  InternationalDriverLicenseGeneralSection,
  InternationalDriverLicenseDetailsSection,
  InternationalDriverLicenseLegalizedCopiesSection,
];
